export default __webpack_public_path__ + "static/media/e-school.e7d331e1.png";